import React, {Component} from 'react'
import {connect} from "react-redux";
import styled from '@emotion/styled'
import {MediaList} from '../components/media/MediaList'
import {MediaDetails} from '../components/media/MediaDetails'
import {sourceActions} from "../_actions";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {uiConstants} from "../_constants";
import {userService} from "../_services";
import {Container, MediaContent, StyledMedia} from "../styles/CommonStyler";
import LoaderMessage from "../_components/LoaderMessage";
import {isMobileOnly} from "react-device-detect";
import {__isKeyAvailable, sourceHelper} from "../_helpers";
import {withTranslation} from "react-i18next";
import {MediaBase} from "../components/media/MediaBase";
import debounce from "lodash/debounce";

// STYLE ##########################################################

const SideBar = styled(`div`)`
  flex: 0 0 auto;
  align-self: start;
  height: ${props => props.height}px;
  max-height: 100%;
  border-radius: 6px;
  background: #F2F2F2;
`;

// COMPONENT ##########################################################

class Media extends Component {
  
  state = {
    maxHeight: 0,
  }

  componentDidMount() {
    // dispatch to fetch the list of user's sources
    this.props.getSources();
    window.addEventListener("resize", this.updateHeight.bind(this));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // check if sources have been loaded
    if (this.props.sources.list !== prevProps.sources.list && this.props.sources.list) {  // if list is different
      this.updateHeight();  // update height
      const isSelectedItemAvailableAndValid = __isKeyAvailable(this.props.currentSource, "selectedItem")
          && sourceHelper.isSourceInList(this.props.sources.list, this.props.currentSource.selectedItem);

      (isSelectedItemAvailableAndValid)
          ? this.props.selectItem(this.props.currentSource.selectedItem)  // select current source
          : this.props.selectItem(this.props.sources.list[0]);            // select first item as default/fallback
    }
    
    if (prevProps.currentSource !== this.props.currentSource) { // if different item is selected
      this.updateHeight();  // update height
    }
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateHeight.bind(this));
  }
  
  updateHeight = debounce(() => {
    if (this.mediaContainer && this.mediaContainer.offsetHeight) {
      this.setHeight(this.mediaContainer.offsetHeight);
    }
  }, 250);
  
  setHeight = (height) => {
    this.setState({ maxHeight: height });
  }

  render() {
    const { sources, currentSource, users, t } = this.props;

    const isConnectedToZoom = userService.isConnectedToZoom(users);
    const isMediaListEmpty = sources.loaded && !sources.list;

    return (
        <StyledMedia >
        <Container isMobile={isMobileOnly}>

          <Header
              screen={uiConstants.HEADER_MEDIA}
              isConnectedToZoom={isConnectedToZoom}
              hideOrderOrPortfolio={isMediaListEmpty}
          />

          { sources.loaded && currentSource.selectedItem &&
          <MediaContent ref={elm => {this.mediaContainer = elm}} >
            <SideBar height={this.state.maxHeight}>
              <MediaList />
            </SideBar>
            <MediaDetails />
          </MediaContent>
          }

          { sources.loading &&
          LoaderMessage({
	          title: '',
	          messages: [],
	          alert: alert,
	          loadingText: t("Loading..."),
          })
          }

          { isMediaListEmpty &&
            <MediaBase />
          }

          <Footer />

        </Container>
      </StyledMedia>
    )
  }
}

function mapStateToProps(state) {
  const { users, sources, gists, currentSource } = state;
  return {
    users, sources, gists, currentSource
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSources: () => dispatch( sourceActions.getSources() ),
    selectItem: (item) => dispatch( sourceActions.setCurrentSource(item) )
  }
}

const connectedMedia = withTranslation() (connect(mapStateToProps, mapDispatchToProps)(Media));
export { connectedMedia as Media };
